/** Where the service worker keeps the API's last answers (`public/sw.js`). */
export const API_CACHE = 'trippath-api';

/**
 * Registers the service worker (`public/sw.js`) in a built app, so it opens without a connection;
 * development runs without one, so a change shows at once.
 */
export function registerWorker(where: Navigator, production: boolean): void {
  if (production && 'serviceWorker' in where) {
    where.serviceWorker.register('/sw.js').then(
      () => undefined,
      () => undefined,
    );
  }
}

/** Forgets the API answers kept for offline use: after signing out, the next person sees none. */
export async function forgetOffline(): Promise<void> {
  if ('caches' in window) await caches.delete(API_CACHE);
}

/** Whether a service worker answers this page, so what is fetched now is there offline. */
export function workerActive(where: Navigator): boolean {
  return 'serviceWorker' in where && where.serviceWorker.controller !== null;
}

/** Fetches each address so the service worker keeps it for offline use; whether every one came. */
export async function keepFiles(urls: string[]): Promise<boolean> {
  const answers = await Promise.all(
    urls.map((url) =>
      fetch(url).then(
        (answer) => answer.ok,
        () => false,
      ),
    ),
  );
  return answers.every(Boolean);
}
